export default "__VITE_ASSET__CgZEXqXe__"